import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
import Validated from 'components/util/Validated';

import { createRoute } from 'lib/util';

const GroupForm = ({
  company,
  errors,
  handleSubmit,
  handleValueChange,
  handleCustomCheck,
  isSaving,
  isSubmitted,
  subcompany,
  t,
  values,
  customs = [],
}) => {
  if (!Array(customs)) customs = [];
  if (!Array(values.custom) || !values.custom) values.custom = [];

  const isCustomChecked = (id) => {
    let response = false;
    values.custom.some((custom) => {
      if (custom._id == id) return (response = true);
    });
    return response;
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <div className="col-md-12 mt-3">
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('groups.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('groups.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.FieldInput
              error={(isSubmitted && errors.description) || {}}
              name={'description'}
              label={t('groups.fields.description')}
              handleChange={handleValueChange}
              t={t}
              value={values.description}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            {/* <Form.FieldInput
              type="arreglo"
              error={(isSubmitted && errors.module) || {}}
              name={"module"}
              label={t("groups.fields.module")}
              handleChange={handleValueChange}
              t={t}
              value={values.module}
            /> */}
            <Form.FieldSelect
              error={(isSubmitted && errors.module) || {}}
              name={'module'}
              label={t('groups.fields.module')}
              handleChange={handleValueChange}
              value={values.module}
            >
              <option value={'empleados'}>{t('groups.moduleDropDown.employees')}</option>
              <option value={'centro_de_costos'}>{t('groups.moduleDropDown.centerCost')}</option>
              <option value={'proveedores'}>{t('groups.moduleDropDown.providers')}</option>
              <option value={'proyecto'}>{t('groups.moduleDropDown.projects')}</option>
              <option value={'tipo_de_activo'}>{t('groups.moduleDropDown.typeAssets')}</option>
              <option value={'cuentas_contables'}>
                {t('groups.moduleDropDown.contableAccounts')}
              </option>
              <option value={'depreciaciones'}>{t('groups.moduleDropDown.depreciations')}</option>
              <option value={'activos'}>{t('groups.moduleDropDown.assets')}</option>
            </Form.FieldSelect>
          </div>

          <div className="col-12">
            <Form.Section title={t('groups.fields.customs')}>
              {customs.map((custom) => (
                <div className="col-sm-6 col-md-4 col-lg-3">
                  <Form.Checkbox
                    label={custom.name}
                    className="icheckbox_flat-blue"
                    value={custom.id}
                    onChange={handleCustomCheck}
                    name={custom.name}
                    checked={isCustomChecked(custom.id)}
                  />
                  <br></br>
                </div>
              ))}
            </Form.Section>
          </div>
        </div>
      </div>

      <div className="col-md-12 mt-3">
        <Form.Link
          to={createRoute(company.id, subcompany.id, `custom_fields_employees`)}
          className={classnames('btn btn-secondary pull-left mr-3', {
            disabled: isSaving,
          })}
        >
          {t('groups.fields.customs')}
        </Form.Link>

        <Form.Button
          type={'submit'}
          text={t('actions.save')}
          isLoading={isSaving}
          disabled={isSaving}
          extraClassName={'pull-right btn-xs-block'}
        />

        <Form.Link
          to={createRoute(company.id, subcompany.id, `groups`)}
          className={classnames('btn btn-secondary pull-right mr-3', {
            disabled: isSaving,
          })}
        >
          {t('actions.cancel')}
        </Form.Link>
        <div className="clearfix" />
      </div>
    </form>
  );
};

export default Validated({
  type: 'object',
  properties: {
    key: {
      type: 'string',
      minLength: 1,
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    description: {
      type: 'string',
      minLength: 1,
    },
  },
  required: ['key', 'name', 'description'],
})(translate()(GroupForm));



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/components/form/GroupForm.js